import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { Union } from 'ts-toolbelt';

import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isDateInPast, isDateOnOrAfterDOB, isPresent } from 'forms/validators';

import { SleepApneaFormValues } from '../form/types';

export const getValidator = ({ dateOfBirth }: { dateOfBirth: Union.Nullable<string> }) => {
  const dobValidator = composeValidators(isPresent, isDateInPast, isDateOnOrAfterDOB(dateOfBirth));

  return ({
    diagnosedAt,
    severity,
    everTreated,
    treatedAt,
    usesCPAPMachine,
    sleepStudyConducted,
    sleepStudyConductedAt,
  }: InitialValues<SleepApneaFormValues>): ValidationErrors<SleepApneaFormValues> => {
    const errors: ValidationErrors<SleepApneaFormValues> = {
      diagnosedAt: dobValidator(diagnosedAt),
      severity: isPresent(severity),
      everTreated: isPresent(everTreated),
      sleepStudyConducted: isPresent(sleepStudyConducted),
    };

    if (everTreated) {
      errors.treatedAt = dobValidator(treatedAt);
      errors.usesCPAPMachine = isPresent(usesCPAPMachine);
    }

    if (sleepStudyConducted) {
      errors.sleepStudyConductedAt = dobValidator(sleepStudyConductedAt);
    }

    return omitBy(errors, isNil);
  };
};
